import React, { useContext, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, CircularProgress, DialogContent, TextField, Typography } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import AnyDialog from '../AnyDialog';
import AppContext from '../../Services/AppContext';
import PersistantData from '../../Services/PersistantData';

const useStyles = makeStyles((theme) => ({
	content: {
		paddingTop: 0
	},
	headerRow: {
		display: 'flex',
		alignItems: 'center',
		marginBottom: theme.spacing(1)
	},
	headerIcon: {
		color: '#FEF200',
		marginRight: theme.spacing(1)
	},
	reason: {
		marginTop: theme.spacing(2)
	}
}));

export default function OutletActivateDialog({ open, outletName, loading, onCancel, onConfirm }) {
	const classes = useStyles();
	const [reason, setReason] = useState('');
	const [gState] = useContext(AppContext);
	const singleton = PersistantData.getInstance();
	var { translation: language } = gState;
	if (typeof (language) === 'undefined') {
		language = singleton.getlang();
	}

	useEffect(() => {
		if (open) {
			setReason('');
		}
	}, [open]);

	return (
		<AnyDialog
			open={open}
			onDismiss={onCancel}
			maxWidth={'xs'}
			title={
				<span className={classes.headerRow}>
					<CheckCircleOutlineIcon className={classes.headerIcon} />
					<Typography variant={'h6'} component={'span'}>
						{language.activate_outlet}
					</Typography>
				</span>
			}
			footer={() =>
				<>
					<Button onClick={onCancel} disabled={loading} color={'primary'}>
						{language.cancel}
					</Button>
					<Button
						onClick={() => onConfirm(reason.trim())}
						disabled={loading || reason.trim() === ''}
						color={'primary'}
						variant={'contained'}
						startIcon={loading ? <CircularProgress size={16} color={'inherit'} /> : null}>
						{language.activate}
					</Button>
				</>
			}>
			<DialogContent className={classes.content}>
				<Typography variant={'body2'}>
					<b>{outletName}</b> {language.activate_outlet_confirm}
				</Typography>
				<TextField
					className={classes.reason}
					label={language.reason_note}
					value={reason}
					onChange={(e) => setReason(e.target.value)}
					disabled={loading}
					required
					fullWidth
					multiline
					rowsMax={3}
					inputProps={{ maxLength: 255 }}
					helperText={reason.trim() === '' ? language.reason_required : ''}
				/>
			</DialogContent>
		</AnyDialog>
	);
}
